// index.js
import { createStore } from 'vuex';
import { getAuth, onAuthStateChanged } from 'firebase/auth';

export default createStore({
    state() {
        return {
            user: null,
            votingUser: JSON.parse(sessionStorage.getItem('votingUser')) || undefined,
            workshopId: sessionStorage.getItem('workshopId') || undefined,
            userVote: JSON.parse(sessionStorage.getItem('userVote')) || undefined,
            customerId: sessionStorage.getItem('customerId') || undefined,
        };
    },
    mutations: {
        setUser(state, user) {
            state.user = user;
        },
        setWorkshopId(state, workshopId) {
            state.workshopId = workshopId;
        },
        setVotingUser(state, votingUser) {
            state.votingUser = votingUser;
        },
        setUserVote(state, userVote) {
            state.userVote = userVote;
        },
        setCustomerId(state, customerId) {
            state.customerId = customerId;
        },
    },
    actions: {
        fetchUser({ commit }) {
            const auth = getAuth();
            onAuthStateChanged(auth, (user) => {
                commit('setUser', user);
            });
        },
        saveVotingUser({ commit }, votingUser) {
            commit('setVotingUser', votingUser); // Aktion zum Speichern des Benutzers im Zustand
            sessionStorage.setItem('votingUser', JSON.stringify(votingUser));
        },
        saveWorkshopId({ commit }, workshopId) {
            commit('setWorkshopId', workshopId); // Aktion zum Speichern des Benutzers im Zustand
            sessionStorage.setItem('workshopId', workshopId);
        },
        saveUserVote({ commit }, userVote) {
            commit('setUserVote', userVote); // Aktion zum Speichern des Benutzers im Zustand
            sessionStorage.setItem('userVote', JSON.stringify(userVote));
        },
        saveCustomerId({ commit }, customerId) {
            commit('setCustomerId', customerId); // Aktion zum Speichern des Benutzers im Zustand
            sessionStorage.setItem('customerId', customerId);
        },
    },
    getters: {
        currentUser(state) {
            return state.user;
        },
        getVotingUser: (state) => state.votingUser,
        getWorkshopId: (state) => state.workshopId,
        getUserVote: (state) => state.userVote,
        getCustomerId: (state) => state.customerId,
    }
});
